module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"Aggiorna contenuti","touDialogConfirmLabel":"Accedi e accetta le condizioni d’uso","touDialogTitle":"Condizioni d’uso di Adobe Experience Cloud","touTextLine1":"Le condizioni d’uso di Adobe Experience Cloud sono state aggiornate.","touTextLine2a":"Accedi a","touTextLine2b":"e accetta le condizioni d’uso aggiornate prima di continuare.","touTextLine3":"Dopo aver accettato le condizioni d’uso, fai clic su Aggiorna contenuti."}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/it_it.json
// module id = 917
// module chunks = 0